import React, { useState } from 'react';
import Button from '../Button';
import { StyledDeleteAccount } from './DeleteAccountModal.style';

const DeleteAccountModal = ({ onClose }) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      onClose();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  return (
    <StyledDeleteAccount>
      <div className="desc">
        <p>Before you delete your account, please take a moment to understand what will happen to your data:</p>
        <p>
          Your profile details, preferences, and settings will be removed. Your search history, threads, and any other
          content you've shared will be deleted.
        </p>
        <p>
          All data will be permanently deleted 30 days after account deletion. If you have an active Pro subscription,
          please click “Subscription”, then “Cancel” to cancel your subscription before deleting your account.
        </p>
      </div>
      <div className="btn-holder">
        <Button width="136px" variant="secondary-outline" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button width="170px" onClick={() => handleSubmit()} loader={loading}>
          Confirm
        </Button>
      </div>
    </StyledDeleteAccount>
  );
};

export default DeleteAccountModal;
